var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUgandaIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 60,
    viewBox: "0 0 80 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10239_105594)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_10239_105594",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 80,
    height: 60
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.00390625 0H79.9961V60H0.00390625V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_10239_105594)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5 40.0078H85V50.0039H-5V40.0078Z",
    fill: "#FFE700"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5 30H85V39.9961H-5V30Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5 20.0039H85V30H-5V20.0039Z",
    fill: "#DE3908"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5 10.0078H85V20.0039H-5V10.0078Z",
    fill: "#FFE700"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5 0H85V9.99609H-5V0Z",
    fill: "#000001"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49.3398 30C49.3398 32.4771 48.3558 34.8527 46.6043 36.6043C44.8527 38.3558 42.4771 39.3398 40 39.3398C37.5229 39.3398 35.1473 38.3558 33.3957 36.6043C31.6442 34.8527 30.6602 32.4771 30.6602 30C30.6602 27.5229 31.6442 25.1473 33.3957 23.3957C35.1473 21.6442 37.5229 20.6602 40 20.6602C42.4771 20.6602 44.8527 21.6442 46.6043 23.3957C48.3558 25.1473 49.3398 27.5229 49.3398 30Z",
    fill: "#FFFDFF",
    stroke: "black",
    strokeWidth: 0.117188
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.3594 22.8398L37.75 21.7266C37.9844 21.4922 38.3711 21.3047 39.0039 21.3047L38.9336 22.5352L38.3594 22.8398Z",
    fill: "#DE3108",
    stroke: "black",
    strokeWidth: 0.117188
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9453 22.5347L39.0273 21.3042C39.0273 21.3042 40.2813 21.2339 40.9609 22.0542L40.293 23.0152L38.9453 22.5347Z",
    fill: "#FFE700",
    stroke: "black",
    strokeWidth: 0.117188
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.3047 23.0039L40.9258 22.043C41.3359 22.4766 41.5117 22.7812 41.5703 23.25C41.582 23.2617 40.5977 23.4961 40.5977 23.4844L40.3047 23.0039Z",
    fill: "#DE3108",
    stroke: "black",
    strokeWidth: 0.117188
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6643 38.8016C38.6643 38.8016 39.8244 37.4774 42.0744 37.7586C41.7346 37.2079 40.633 37.2782 40.633 37.2782C40.633 37.2782 40.3049 34.7001 40.5627 34.5594C40.8205 34.4188 41.9689 34.5711 41.9689 34.5711C42.1096 34.5711 42.3674 34.1727 42.1564 33.9149C41.9572 33.6571 41.3596 32.6844 41.6057 32.4852C41.8518 32.2977 43.176 32.6024 43.176 32.6024L39.426 27.7977C39.426 27.7977 39.0393 25.9813 39.8127 25.1024C40.7385 24.3407 40.633 23.5086 40.6096 23.5204C40.4807 22.6766 39.2033 22.079 38.3361 22.8524C37.8322 23.4618 38.1721 23.9305 38.1721 23.9305C38.1721 23.9305 36.8244 24.2938 36.7775 24.5282C36.7189 24.7626 38.2893 24.493 38.2893 24.493L38.1369 25.5594C38.1369 25.5594 35.09 28.3251 37.4338 30.7157L37.5041 30.6219C37.5041 30.6219 38.3244 31.6297 39.1799 31.8524C40.0002 32.6727 39.9182 32.5555 39.9182 32.5555C39.9182 32.5555 40.0705 33.8563 39.9182 34.1141C39.7189 34.0555 37.6564 33.9735 37.3518 34.0907C37.0705 34.1844 36.0158 34.1258 36.2736 35.8602L36.6604 34.9813C36.6604 34.9813 36.6252 35.6024 36.883 35.8251C36.8361 35.1688 37.1291 34.7235 37.1291 34.7235C37.1291 34.7235 37.176 35.4501 37.34 35.5438C37.5041 35.661 37.5041 34.3719 38.3947 34.4891C39.2619 34.5946 39.9064 34.5594 39.9064 34.5594C39.9064 34.5594 40.1994 37.0672 40.1057 37.3016C39.4728 37.1493 37.9494 37.3602 37.8557 37.7469C38.7463 37.6883 39.1564 37.7938 39.1564 37.7938C39.1564 37.7938 38.4416 38.4383 38.6643 38.8016Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 0.105469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.0161 25.1719C39.0161 25.1719 36.8012 27.6094 37.7622 29.4727C37.8091 29.2148 37.7856 29.0508 37.8208 29.0625C37.7622 29.0273 38.0903 29.2852 38.0669 29.2383C38.0669 29.0977 37.9731 28.8047 37.9731 28.8047L38.2661 28.8867L38.0903 28.5586L38.5239 28.6055C38.5239 28.6055 38.3716 28.207 38.4184 28.207L38.77 28.2305C38.1372 27.1055 38.7348 26.168 39.0161 25.1602V25.1719Z",
    fill: "#9CA69C",
    stroke: "#9CA69C",
    strokeWidth: 0.105469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.7892 23.0742C39.7892 23.0742 39.9064 23.918 39.4377 24.1523C39.3791 24.2109 39.0861 24.3047 39.133 24.4805C39.1799 24.7148 39.3088 24.668 39.4845 24.6211C39.965 24.5391 40.5275 23.5195 39.7892 23.0742Z",
    fill: "#9CA69C",
    stroke: "#9CA69C",
    strokeWidth: 0.117188
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.9688 23.7891C38.9688 23.8357 38.9502 23.8804 38.9173 23.9134C38.8843 23.9463 38.8396 23.9648 38.793 23.9648C38.7463 23.9648 38.7016 23.9463 38.6687 23.9134C38.6357 23.8804 38.6172 23.8357 38.6172 23.7891C38.6172 23.7424 38.6357 23.6977 38.6687 23.6648C38.7016 23.6318 38.7463 23.6133 38.793 23.6133C38.8396 23.6133 38.8843 23.6318 38.9173 23.6648C38.9502 23.6977 38.9688 23.7424 38.9688 23.7891Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.254 24.4922C38.1368 24.5977 37.5274 25.2305 38.1368 25.4648C38.7579 25.3008 38.5821 25.1836 38.7227 25.043C38.7227 24.75 38.4181 24.6797 38.254 24.5039V24.4922Z",
    fill: "#DE3108",
    stroke: "black",
    strokeWidth: 0.117188
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.6013 30.5273C39.5661 30.668 39.4255 31.1836 39.613 31.582C40.152 31.3477 40.3981 31.418 40.5739 31.5352C40.1403 31.1836 39.9645 31.0312 39.6013 30.5273Z",
    fill: "#9CA69C",
    stroke: "#9CA69C",
    strokeWidth: 0.105469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.5156 32.9414L40.5391 34.1367C40.5391 34.1367 40.9609 34.207 41.1484 34.1367C41.3359 34.0664 41.1484 33.3164 40.5156 32.9414Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 0.105469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.5161 33.094C43.5161 33.094 42.7544 31.2425 40.7973 30.7737C38.8403 30.305 39.0981 28.219 39.2505 28.0901C39.3442 27.9143 39.4028 27.6331 39.9653 27.9026C40.5278 28.1721 43.1294 29.4729 43.5044 29.5432C43.8794 29.6135 43.5512 33.1409 43.5278 33.094H43.5161Z",
    fill: "#9CA69C",
    stroke: "black",
    strokeWidth: 0.117188
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.6644 30.7617C41.6293 30.7852 44.2777 32.332 43.4808 33.6563C44.2308 33.1523 43.9964 32.2852 43.9964 32.2852C43.9964 32.2852 44.6058 33.8906 43.1058 34.6758C43.2699 34.8164 43.3753 34.793 43.3753 34.793L43.1175 35.0391C43.1175 35.0391 43.0003 35.2383 44.0082 34.7461C43.7386 34.9687 43.7152 35.1328 43.7152 35.1328C43.7152 35.1328 43.7855 35.3438 44.4418 34.7695C43.9144 35.3438 43.7972 35.6367 43.7972 35.625C45.2386 35.5078 48.3675 30.8203 42.8128 29.4492L43.0589 29.707L41.6644 30.7617Z",
    fill: "#DE3108",
    stroke: "black",
    strokeWidth: 0.105469,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7815 30.3038C42.133 30.5616 42.2619 30.6553 42.3088 30.7725C41.9807 30.7022 41.6877 30.7257 41.6877 30.7257C41.6877 30.7257 40.9729 30.046 40.844 29.9874C40.7502 29.9874 40.1877 29.6358 40.1877 29.6358C39.9182 29.4952 39.6604 28.546 40.6799 28.8155C41.071 29.0194 41.4741 29.1995 41.8869 29.3546L43.1408 29.753L43.8674 30.5616C43.8674 30.5616 42.5783 29.9288 42.4143 29.9171C42.7658 30.1983 42.9651 30.5967 42.9651 30.5967C42.5549 30.4796 42.2033 30.3624 41.7815 30.3038Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 0.105469,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.7656 24.5967C36.7656 24.5967 37.9961 24.292 38.1484 24.3389",
    stroke: "white",
    strokeWidth: 0.105469,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5 50.0039H85V60H-5V50.0039Z",
    fill: "#DE3908"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10239_105594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 60,
    rx: 4,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUgandaIcon);
export default __webpack_public_path__ + "static/media/ugandaIcon.19944aa6a8496ec774020a35e2ac6396.svg";
export { ForwardRef as ReactComponent };